import { useEffect, useMemo } from 'react';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { Table } from './../../table/table';
import { ITableColumn, TableModel, TableRow } from './../../table/table.model';
import { runInAction } from 'mobx';
import { useHistory } from 'react-router';
import routes from 'routes';
import { ImportJobVM } from 'app/stores/ui/admin.imports.ui.store';
import { formatDate, formatDateLong } from 'app/utils';
import { Icon } from 'app/components/common/Icon';
import { DottedTag } from 'app/components/common/DottedTag';

interface AdminImportJobsListProps {
	searchFilter: string;
}

export const AdminImportJobsList = observer(({ searchFilter }: AdminImportJobsListProps) => {
	const { adminImportsUiStore } = useStore();
	const history = useHistory();

	const tm = useMemo(() => {
		const viewDoc = (doc: ImportJobVM) => {
			runInAction(() => {
				history.push(routes.ADMINIMPORTS.getPath('job', doc.job.id));
			});
		};

		const tm = new TableModel<ImportJobVM, number>();
		let cols: ITableColumn<ImportJobVM, number>[] = [
			{
				label: 'Quelle',
				path: 'job.dataType',
			},
			{
				label: 'Datum',
				path: 'job.created',
				format: (val) => formatDateLong(val),
			},
			{
				label: 'KW / BM',
				path: 'KW',
				render: (row) => <>{row.data.kwFormated}</>
			},
			{
				label: 'Datenstand',
				path: 'job.meta.datenStand',
				render: (row: TableRow<ImportJobVM>) => <>
					{row.data.job.meta && formatDate(row.data.job.meta.datenStand)}
					{row.data.datenStand && <>
						&nbsp; <DottedTag color={row.data.datenStand.color} text={row.data.datenStand.ageInDays.toString()} />
					</>}
				</>
			},
			{
				label: 'Status',
				path: 'job.status',
			},
			{
				label: 'Fehler',
				path: 'fehler',
				render: (row: TableRow<ImportJobVM>) => <>{(row.data.job.hasError || row.data.job.hasError2) && <Icon iconClass={'bomb'} />}</>,
			},
		];

		tm.onRowClick = (row: TableRow<ImportJobVM>) => {
			viewDoc(row.data);
		};

		tm.setCols(cols);
		tm.sortBy = 'job.created';
		tm.sortAsc = false;
		tm.idProperty = 'id';
		tm.idType = 'string';
		return tm;
	}, [history]);

	useEffect(() => {
		adminImportsUiStore.findAll();
		const filtered = searchFilter
			? adminImportsUiStore.currentItems.filter(item =>
				item.job.dataType.toLowerCase().includes(searchFilter.toLowerCase())
			)
			: adminImportsUiStore.currentItems;
		tm.setRowData(filtered);
	}, [adminImportsUiStore, adminImportsUiStore.currentItems, tm, searchFilter]);

	return (
		<>
			<Table stickyHeader={true} tm={tm}></Table>
		</>
	);
});
